import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Flex from '@wix/da-ds/pkg/Flex';
import StickyBar from '../../StickyBar';
import SearchField from '../../SearchField';
import SortOrderSwitcher from '../../SortOrderSwitcher';

import s from './SearchResultsBar.scss';

export interface Props {
  searchQuery: string;
  isSearching: boolean;
  resultsTotal: number;
}

export const SearchResultsBar: React.FC<Props> = ({
  searchQuery,
  resultsTotal,
  isSearching,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  const renderSearchingState = () => (
    <span className={s['primary-text']}>
      <Trans i18nKey="pages.gallections.search.searchingFor">
        Searching for “<strong>{{ searchQuery }}</strong>” in{' '}
        <strong>All</strong>
      </Trans>
    </span>
  );

  const renderShowingResultsState = isStickyBarStuck => (
    <Flex fullWidth className={s['root']}>
      <Flex fullWidth alignItems="center">
        <span className={s['primary-text']}>
          <Trans i18nKey="pages.gallections.search.showingSearchResultForIn">
            Showing Search result for “<strong>{{ searchQuery }}</strong>” in{' '}
            <strong>All</strong>
          </Trans>
        </span>
        {resultsTotal > 0 && (
          <span className={s['secondary-text']}>
            {t('pages.gallections.search.resultsCount', {
              count: resultsTotal,
            })}
          </span>
        )}
      </Flex>
      <Flex fullWidth justifyContent={isMobile ? 'center' : 'flex-end'}>
        {isStickyBarStuck || isMobile ? (
          <SearchField className={s['search-field']} />
        ) : (
          resultsTotal > 0 && (
            <SortOrderSwitcher className={s['sort-order-switch']} />
          )
        )}
      </Flex>
    </Flex>
  );

  const renderBarContent = isStickyBarStuck =>
    isSearching
      ? renderSearchingState()
      : renderShowingResultsState(isStickyBarStuck);

  return <StickyBar>{renderBarContent}</StickyBar>;
};
SearchResultsBar.displayName = 'SearchResultsBar';

export default SearchResultsBar;
